module.exports = "/_next/static/images/7f1ce8fa2a67ee1d685caca1f30e04f4-box-coin-icon.svg";